// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3fPTm","footer":"ModalFilter_footer__132nw"};